export enum MonumentationType {
  flat_marker = 'flat_marker',
  flush_bronze = 'flush_bronze',
  flush_granite = 'flush_granite',
  glass_front = 'glass_front',
  granite_front = 'granite_front',
  marble_front = 'marble_front',
  marker_hickey = 'marker_hickey',
  marker_slant = 'marker_slant',
  other = 'other',
  upright_monument = 'upright_monument',
}

export const MonumentationTypeShown = {
  [MonumentationType.flat_marker]: 'Flat Marker',
  [MonumentationType.flush_bronze]: 'Flush Bronze',
  [MonumentationType.flush_granite]: 'Flush Granite',
  [MonumentationType.glass_front]: 'Glass Front',
  [MonumentationType.granite_front]: 'Granite Front',
  [MonumentationType.marble_front]: 'Marble Front',
  [MonumentationType.marker_hickey]: 'Marker Hickey',
  [MonumentationType.marker_slant]: 'Marker Slant',
  [MonumentationType.other]: 'Other',
  [MonumentationType.upright_monument]: 'Upright Monument',
};

export const IS_MONUMENTATION_TYPE_SHOW = window.SHOW_MONUMENTATION_TYPE || false;
